import withLayout from './withLayout';

export default withLayout;
